<nav class="breadcrumb">
  <ul>
    <li class="home hidden-sm hidden-xs">
      <a [routerLink]="['/']">
        <fa-icon [icon]="faHouse" size="sm" class="fa-light"></fa-icon>
      </a>
    </li>
    @if (breadcrumbs.length > 1) {
      <li class="home-mobile hidden-md hidden-lg">
        <a (click)="navigateToParent()">
          <fa-icon [icon]="faChevronLeft" size="1x" class="fa-light"></fa-icon>
        </a>
      </li>
    }
    @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
      @if (i + 1 < breadcrumbs.length) {
        <li class="hidden-sm hidden-xs">
          <fa-icon [icon]="faChevronRight" size="xs" class="fa-light"></fa-icon>
          <div>
            <a [routerLink]="[breadcrumb.url]">
              <span class="black">{{ breadcrumb.label | i18nextCap }}</span>
            </a>
          </div>
        </li>
      } @else {
        <li>
          <fa-icon
            [icon]="faChevronRight"
            size="xs"
            class="fa-light hidden-sm hidden-xs"
          ></fa-icon>
          <div>
            <span class="black">{{
              breadcrumb.label | i18nextCap: { nsSeparator: false }
            }}</span>
          </div>
        </li>
      }
    }
  </ul>
</nav>
